import { Column } from '@tanstack/react-table';
import { Table as TanstackTable } from '@tanstack/table-core/build/lib/types';
import debounce from 'lodash/debounce';

const observers = new WeakMap<HTMLElement, ResizeObserver>();

export const setColumnSizes = <TData>(
  thElem: HTMLTableCellElement | null,
  table: TanstackTable<TData>,
  column: Column<TData>,
) => {
  if (!thElem || table.getState().columnSizing[column.id] === thElem.getBoundingClientRect().width) {
    return;
  }

  const tableContainer = thElem.closest('table')?.parentElement;
  if (!tableContainer) {
    return;
  }
  const updateSizes = debounce(
    () => {
      table.setColumnSizing((prevSizes) => ({
        ...prevSizes,
        [column.id]: thElem.getBoundingClientRect().width,
      }));
    },
    150,
    { trailing: true, leading: true },
  );

  updateSizes();

  if (!observers.has(tableContainer)) {
    const observer = new ResizeObserver(() => {
      updateSizes();
    });
    observer.observe(tableContainer);
    observers.set(tableContainer, observer);
  }
};
